export const GetPostflightMissionSummaryRequestSchema = Schema.transform(
  Schema.Struct({
    mission_id: MissionIdSchema
  }),
  Schema.Struct({
    missionId: MissionIdSchema
  }),
  {
    strict: true,
    decode: (api) => ({ missionId: api.mission_id }),
    encode: (client) => ({ mission_id: client.missionId })
  }
);
export type GetPostflightMissionSummaryRequest = Schema.Schema.Type<typeof GetPostflightMissionSummaryRequestSchema>;

export const DeliveryOutcome = {
  DELIVERED: 'delivered',
  CANCELED: 'canceled',
  ABORTED: 'aborted',
  OTHER: 'other'
} as const;

import { Schema } from 'effect';
import { MissionIdSchema } from './mission';

export const DeliveryOutcomeSchema = Schema.Literal(
  DeliveryOutcome.DELIVERED,
  DeliveryOutcome.CANCELED,
  DeliveryOutcome.ABORTED,
  DeliveryOutcome.OTHER
);

export type DeliveryOutcome = Schema.Schema.Type<typeof DeliveryOutcomeSchema>;

export const PostflightMissionSummarySchema = Schema.transform(
  Schema.Struct({
    order_name: Schema.optional(Schema.NullOr(Schema.String)),
    package_weight_kg: Schema.optional(Schema.NullOr(Schema.Number)),
    distance_travelled_m: Schema.Number,
    battery_consumed_pct: Schema.Number,
    delivery_outcome: DeliveryOutcomeSchema
  }),
  Schema.Struct({
    orderName: Schema.optional(Schema.NullOr(Schema.String)),
    packageWeightKg: Schema.optional(Schema.NullOr(Schema.Number)),
    distanceTravelledM: Schema.Number,
    batteryConsumedPct: Schema.Number,
    deliveryOutcome: DeliveryOutcomeSchema
  }),
  {
    strict: true,
    decode: (api) => ({
      orderName: api.order_name,
      packageWeightKg: api.package_weight_kg,
      distanceTravelledM: api.distance_travelled_m,
      batteryConsumedPct: api.battery_consumed_pct,
      deliveryOutcome: api.delivery_outcome
    }),
    encode: (client) => ({
      order_name: client.orderName,
      package_weight_kg: client.packageWeightKg,
      distance_travelled_m: client.distanceTravelledM,
      battery_consumed_pct: client.batteryConsumedPct,
      delivery_outcome: client.deliveryOutcome
    })
  }
);
export type PostflightMissionSummary = Schema.Schema.Type<typeof PostflightMissionSummarySchema>;
